import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.909 7.083v-.416a2.708 2.708 0 0 0-5.417 0v2.65c0 .039 0 .076.003.115.02.316.166 1.844 1.065 2.065m6.849-.872s-.209 3.75-5.209 3.75c-.285 0-.555-.012-.81-.035m-4.398-3.715s.087 1.576 1.511 2.685m3.697 1.482v2.25m5.209-12.25L4.992 15.208" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);